/**
 * Digital Retailing behavior slug → AMD route mapping
 * Single source of truth for both SRP href synthesis and VDP click handler
 */

export const behaviorRouteMap = {
	'vehicle-dr-dashboard-button': 'dashboard',
	'vehicle-dr-finance-button': 'credit',
	'vehicle-dr-trade-button': 'tradeInSearch'
};

// vehicle-dr-dashboard-button maps to "payment" step in ws-track-my-offer
// which scrolls to UDS instead of opening a modal
export const SCROLL_TO_UDS_BEHAVIORS = new Set(['vehicle-dr-dashboard-button']);

/**
 * Check if a behavior string is a DR CTA button
 * @param {string} behavior - The behavior value from the item
 * @returns {boolean} True if behavior is a recognized DR slug
 */
export const isDRBehavior = (behavior) => {
	return Object.hasOwn(behaviorRouteMap, behavior);
};

/**
 * Check if a DR behavior should scroll to UDS instead of opening SDP modal
 * @param {string} behavior
 * @returns {boolean}
 */
export const isScrollToUDSBehavior = (behavior) => {
	return SCROLL_TO_UDS_BEHAVIORS.has(behavior);
};

/**
 * Get the AMD route for a DR behavior.
 * @param {string} behavior - The behavior value from the item
 * @returns {string|undefined} The route string, or undefined if not found
 */
export const routeForBehavior = (behavior) => {
	return behaviorRouteMap[behavior];
};
